import AuthDTO from "../../../shared/oversight-core/dtos/request-dtos/auth-dto";
import LoginResponseDTO from "../../../shared/oversight-core/dtos/response-dtos/login-response-dto";
import { transformErrorResponse } from "../../../shared/oversight-core/utils/transformErrorResponse";
import { setPrivileges, setToken } from "../../features/auth/auth-slice";
import { rootApi } from "../apiManager";

export const adminAuthAPI = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    adminLogin: builder.mutation<LoginResponseDTO, AuthDTO>({
      query(data) {
        return {
          url: "admin/login",
          method: "POST",
          body: data,
        };
      },
      transformErrorResponse,
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const res = await queryFulfilled;
          if (args.rememberMe) {
            localStorage.setItem("token", res.data.token);
            localStorage.setItem(
              "privileges",
              JSON.stringify(res.data.privileges)
            );
          } else {
            sessionStorage.setItem("token", res.data.token);
            sessionStorage.setItem(
              "privileges",
              JSON.stringify(res.data.privileges)
            );
          }
          dispatch(setToken(res.data.token));
          dispatch(setPrivileges(res.data.privileges));
        } catch (error) {
          console.log(error);
        }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useAdminLoginMutation } = adminAuthAPI;
